// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__iXnLA","titleText":"Title_titleText__a8TiU"};